/*Edit thong tin ve nguon tin va tai nan, phuong tien bi nan */
import React from "react";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import IconButton from "@material-ui/core/IconButton";
import MenuIcon from "@material-ui/icons/Menu";
import Typography from "@material-ui/core/Typography";
import Toolbar from "@material-ui/core/Toolbar";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import FormControl from "@material-ui/core/FormControl";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Switch from "@material-ui/core/Switch";
import TextField from "@material-ui/core/TextField";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import Input from "@material-ui/core/Input";
import MaskedInput from "react-text-mask";
import PropTypes from "prop-types";
import SelectFilter from "react-select";
import Select from "@material-ui/core/Select";
import Checkbox from "@material-ui/core/Checkbox";
import CircularProgress from "@material-ui/core/CircularProgress";
import MyLatLonEditor from "./LatLonEditor";
import DoiTacEditDialog from '../danhmuc/DoiTacEditDialog';

import {
  DatePicker,
  TimePicker,
  MuiPickersUtilsProvider,
  KeyboardDateTimePicker,
} from "@material-ui/pickers";

import moment from "moment";

import MyButton from "../MyButton";

const myLib = require("../../lib/MyLib");
const server = require("../../lib/server");
const sukienLayer = require("../../lib/SuKienDataLayer");
///////////////////////////////////////////////////////////////////
const defaultRecord = {
  TheoDoi: false, //theo doi vu viec hay khong
  PhoiHop: false,
  KieuPhoiHop: "1",
  PhoiHopQT: false, //co phoi hop quoc te khong
  PhoiHopQT_MaQG: null,
};

class SuKienXuLyControl extends React.Component {
  constructor(props) {
    super(props);
    this.saveField = this.saveField.bind(this);
    this.handleSave = this.handleSave.bind(this);
    this.state = {
      canSaved: false, //cho phep save hay khong
      dataChanged: false, //du lieu co su thay doi hay khong
      saving: false, //co dang save du lieu hay khong
      errorLog: "", //mo ta loi neu co
      //danh muc quoc gia
      loading_doitac: true, // co dang loading danh muc quoc gia khong
      source_doitac: [], //danh muc options cho quoc tich
      open_them_doitac: false,
      before:
        props.value === undefined
          ? {
              ThoiGian: new Date(),
            }
          : myLib.cloneObject(props.value), //thong tin truoc khi edit
      after:
        props.value === undefined
          ? defaultRecord
          : { ...defaultRecord, ...props.value }, //thong tin dang edit
      validateStatus: {},
      
    };
  }
  //ghi nhan gia tri nhap
  saveField = (fieldName, value) => {
    var old_changed = this.state.dataChanged;
    var s = this.state;
    s.after[fieldName] = value;
    s.dataChanged = !myLib.isSame(s.before, s.after, [
      "TheoDoi",
      "PhoiHop",
      "KieuPhoiHop",
      "PhoiHopQT",
      "PhoiHopQT_MaQG",
    ]);
    s.canSaved = s.dataChanged;
    console.log(s);
    if(this.props.onChanged && old_changed != s.dataChanged) {
      this.props.onChanged(s.dataChanged);
    }
    this.setState(s);
  };
  //submit thong tin ve DB
  handleSave = () => {
    console.log(JSON.stringify(this.state.after));
    var check = sukienLayer.validate("xuly", this.state.after);
    if (!check.error) {
      this.setState({ validateStatus: check, saving: true, errorLog: "" });
      server
        .post(
          "sukien/saveXuly",
          sukienLayer.chuanHoaSukien("xuly", this.state.after)
        )
        .then((response) => {
          var before = {};
          var after = this.state.after;
          Object.assign(before, after);
          this.setState({
            before: before,
            after: after,
            dataChanged: false,
            canSaved: false,
            saving: false,
            errorLog: "",
          });
          //thong bao cho parent biet co data duoc saved
          if (this.props.onSaved) {
            this.props.onSaved(after);
          }
          if(this.props.onChanged) {
            this.props.onChanged(false);
          }
        })
        .catch((error) =>
          this.setState({ saving: false, errorLog: error + "" })
        );
    } else {
      this.setState({ validateStatus: check });
    }
  };
  loadDanhMuc() {
    //load danh muc tai nan
    server
      .query("doitac/getall")
      .then((response) => {
        var list = [];
        response.map((item, index) => {
          if (item.LoaiDoiTac === 2) {
            list.push({ value: item.MaDoiTac, label: item.TenDoiTac });
          }
        });
        this.setState({ source_doitac: list, loading_doitac: false });
      })
      .catch((error) => {
        console.log(error);
        this.setState({ loading_doitac: false });
      });
  }
  //khi load component: load cac danh muc can thiet
  componentDidMount() {
    this.loadDanhMuc();
  }
  static getDerivedStateFromProps(props, state) {
    var newState = { ...state };
    //console.log("TaiNanControl props:", props.value);
    if (props.value !== undefined && props.value.MaSK !== state.after.MaSK) {
      //console.log("co su thay doi");
      //co su thay doi
      newState = {
        ...newState,
        after: { ...state.after, ...props.value },
      }; //lay thong tin tu parent form truyen vao thong qua props
    }
    //console.log("TaiNanControl new state:", newState);
    return newState;
  }
  render() {
    const { classes, theme } = this.props;
    return (
      <Accordion disabled={this.props.disabled} 
      defaultExpanded={this.props.value !== undefined}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
          classes={{
            root: classes.normalPanel,
            expanded: classes.expandedPanel,
            content: classes.summaryContent
          }}
        >
          <Typography className={classes.heading}>Hoạt động xử lý</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Grid container spacing={2}>
            <Grid item xs={4}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={this.state.after.TheoDoi}
                    onChange={(event) =>
                      this.saveField("TheoDoi", event.target.checked)
                    }
                    name="chkTheoDoi"
                  />
                }
                label="Theo dõi"
              />
            </Grid>
            <Grid item xs={4}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={this.state.after.PhoiHop}
                    onChange={(event) =>
                      this.saveField("PhoiHop", event.target.checked)
                    }
                    name="chkPhoiHop"
                  />
                }
                label="Phối hợp"
              />
            </Grid>
            <Grid item xs={4}>
              <FormControl className={classes.formControl}>
                <InputLabel id="demo-simple-select-label">
                  Loại phối hợp:
                </InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  className={classes.textbox}
                  autoWidth={true}
                  labelWidth={100}
                  value={this.state.after.KieuPhoiHop}
                  onChange={(event) =>
                    this.saveField("KieuPhoiHop", event.target.value)
                  }
                >
                  <MenuItem value={"1"}>Tàu tự cứu</MenuItem>
                  <MenuItem value={"2"}>Tàu trong khu vực</MenuItem>
                  <MenuItem value={"3"}>Tàu quân sự</MenuItem>
                  <MenuItem value={"4"}>Phối hợp quốc tế</MenuItem>
                  <MenuItem value={"0"}>Khác</MenuItem>
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={4}>
              <InputLabel id="labelQuoctich"
              onClick={
                  global.User.Quyen.R121
                    ? (event) => this.setState({ open_them_doitac: true })
                    : undefined
                }
              >Cơ quan phối hợp:</InputLabel>
              {this.state.loading_doitac ? (
                <CircularProgress />
              ) : (
                <SelectFilter
                  id="cboMaQG"
                  options={this.state.source_doitac}
                  placeholder="---Chọn---"
                  labelId="labelQuoctich"
                  value={this.state.after.PhoiHopQT_MaDoiTac}
                  onChange={(item) =>
                    this.saveField("PhoiHopQT_MaDoiTac", item)
                  }
                ></SelectFilter>
              )}
            </Grid>
            <Grid item xs={4}>
              <FormControl className={classes.formControl}>
                <InputLabel id="demo-simple-select-label">
                  Hoạt động:
                </InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  className={classes.textbox}
                  autoWidth={true}
                  labelWidth={100}
                  value={this.state.after.PhoiHopQT}
                  onChange={(event) =>
                    this.saveField("PhoiHopQT", event.target.value)
                  }
                >
                  <MenuItem value={"1"}>Chỉ cung cấp thông tin</MenuItem>
                  <MenuItem value={"2"}>Phối hợp hoạt động</MenuItem>
                  <MenuItem value={"3"}>Điều động phương tiện</MenuItem>
                  <MenuItem value={"0"}>Khác</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={4}>
              {this.state.canSaved ? (
                <MyButton
                  onClick={this.handleSave}
                  color="primary"
                  text="Lưu"
                />
              ) : null}
            </Grid>
            <Grid item xs={10}>
              {this.state.saving ? (
                <CircularProgress />
              ) : this.state.errorLog === "" ? null : (
                this.state.errorLog
              )}
            </Grid>
          </Grid>
          {this.state.open_them_doitac ? (
            <DoiTacEditDialog
              visible={this.state.open_them_doitac}
              fullWidth={true}
              maxWidth={"sm"}
              EditMode="them"
              LoaiDoiTac="2"
              onClose={(result) => {
                this.setState({ open_them_doitac: false });
              }}
              onSaved={(record) => {
                var list = [].concat(this.state.source_doitac);
                var new_item = {
                  value: record.MaDoiTac,
                  label: record.TenDoiTac,
                };
                list.unshift(new_item);
                this.setState({
                  source_doitac: list,
                  dataChanged: true,
                  canSaved: true,
                  after: { ...this.state.after, PhoiHopQT_MaDoiTac: new_item },
                });
              }}
            />
          ) : null}
        </AccordionDetails>
      </Accordion>
    );
  }
}
const styles = (theme) => ({
  form: {
    display: "flex",
    flexDirection: "column",
    margin: "auto",
    width: "fit-content",
    heigh: "fit-content",
  },
  formControl: {
    marginTop: 2,
    minWidth: 120,
  },

  thoigian: {
    marginLeft: 1,
    marginRight: 1,
    width: 200,
  },
  textbox: {
    marginLeft: 1,
    marginRight: 1,
    width: "100%",
  },
  uppercaseText: {
    textTransform: "uppercase",
  },
  normalPanel: {
    backgroundColor: "lightskyblue",
    margin: 0,
    minHeight: 11,
  },
  expandedPanel: {
    backgroundColor: "skyblue",
    margin: 0,
    minHeight: '10px !important',
  },
  summaryContent: {
    margin: '1px !important',
  },
});
export default withStyles(styles, { withTheme: true })(SuKienXuLyControl);
